




import { Component } from 'vue-property-decorator';

import YourAccountComplete from '../default-user-signup/YourAccountComplete.vue';
import BusinessOnboardingModel from '@/views/BusinessOnboarding/BusinessOnboardingModel.vue';

@Component({
  components: { YourAccountComplete }
})
export default class CreateCampaigns extends BusinessOnboardingModel {
  hasFinishTracking = false;

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  async created() {
    try {
      this.$showLoader(true);

      if (!this.businessInfo) await this.onCreateBusiness();
      await this.onCreateAICampaigns();
      await this.redirectAIFlow('replace');
    } finally {
      this.$hideLoader();
    }
  }
}
